const MtrArrowRightOutline={
    "name": "mtr-arrow-right",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M7.30529 18.2807C7.20978 18.373 7.1336 18.4833 7.08119 18.6053C7.02878 18.7273 7.00119 18.8585 7.00004 18.9913C6.99888 19.1241 7.02419 19.2558 7.07447 19.3787C7.12475 19.5016 7.199 19.6132 7.29289 19.7071C7.38679 19.801 7.49844 19.8753 7.62134 19.9255C7.74423 19.9758 7.87591 20.0011 8.00869 20C8.14147 19.9988 8.27269 19.9712 8.39469 19.9188C8.5167 19.8664 8.62704 19.7902 8.71929 19.6947L16.4263 11.9877L8.71929 4.28071C8.53069 4.09855 8.27808 3.99776 8.01589 4.00004C7.75369 4.00232 7.50288 4.10749 7.31747 4.29289C7.13206 4.4783 7.02689 4.72911 7.02461 4.99131C7.02234 5.25351 7.12313 5.50611 7.30529 5.69471L13.5983 11.9877L7.30529 18.2807Z",
                    "fill": "currentColor"
                }
            }
        ]
    }
};
export default MtrArrowRightOutline;